import { baseApi } from '@/lib/utils'

export interface CompanyData {
  id: number
  name: string
  logo: string | null
  timezone: string
  symbol: string | null
  daily_hours: number
  workdays: string
  created_at: string
  updated_at: string
}

export interface CompanyResponse {
  message: string
  data: CompanyData
}

export interface UpdateCompanyPayload {
  name?: string
  logo?: string | null
  timezone?: string
  symbol?: string | null
  daily_hours?: number
  workdays?: string
}

export interface CompanyMetaData {
  name: string
  logo: string
}

export interface CompanyMetaResponse {
  message: string
  data: CompanyMetaData
}

export interface ClickupWorkspace {
  id: string
  name: string
}

export interface ClickupSpace {
  id: string
  name: string
  archived: boolean
}

export interface ClickupFolder {
  id: string
  name: string
  archived: boolean
}

export interface ClickupList {
  id: string
  name: string
  archived: boolean
}

export interface ClickupConfigData {
  workspaces?: ClickupWorkspace[]
  spaces?: ClickupSpace[]
  folders?: ClickupFolder[]
  lists?: ClickupList[]
  sync_frequency?: number
  scheduled_hour?: number
  next_run_at?: string
}

export interface ClickupConfigResponse {
  message: string
  data: ClickupConfigData
}

export interface DatascopeData {
  id: number
  project_hourly_rate: string | number
  employee_hourly_rate: string | number
  datascope: number | boolean
  expense_ratio: string | number
  archived: number | boolean
  created_at: string
  updated_at: string
}

export interface DatascopeResponse {
  message: string
  data: DatascopeData[]
}

export interface UpdateDatascopePayload {
  project_hourly_rate: number
  employee_hourly_rate: number
  datascope: boolean
  expense_ratio: number
  archived: boolean
}

export const datascopeApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getDatascope: builder.query<DatascopeResponse, void>({
      query: () => '/datascope',
      providesTags: ['DataScope'],
    }),

    updateDatascope: builder.mutation<
      DatascopeResponse,
      UpdateDatascopePayload
    >({
      query: body => ({
        url: '/datascope',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['DataScope'],
    }),

    getCompany: builder.query<CompanyResponse, void>({
      query: () => '/company',
      providesTags: ['Company'],
    }),
    getCompanymeta: builder.query<CompanyMetaResponse, void>({
      query: () => '/global',
      providesTags: ['Company'],
    }),
    updateCompany: builder.mutation<
      CompanyResponse,
      UpdateCompanyPayload | FormData
    >({
      query: body => ({
        url: '/company',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Company'],
    }),
  }),
})

export const {
  useGetDatascopeQuery,
  useUpdateDatascopeMutation,
  useGetCompanyQuery,
  useGetCompanymetaQuery,
  useUpdateCompanyMutation,
} = datascopeApi
